import { DASHBOARD_TABS } from 'constants/navs'
import NavTabs from '../NavTabs'

const DashboardNav = () => <NavTabs tabs={DASHBOARD_TABS} checkPermissions />

export default DashboardNav
